<div class="form" id="search">
    <div class="form-main">
        <div class="form-main-fields" id="fields">
            <ng-content select="wbo-search-form-fields"></ng-content>
        </div>
        <div class="form-main-constant" *ngIf="searchExtended">
            <wbo-more-select-control class="filter-select" valueField="field" labelField="label" id="search-filter-control-more"
                                       (valueChange)="setSelectedFormFields($event)"
                                       [data]="searchFormExtendedService.$registeredTemplate | async"
                                       [value]="searchFormExtendedService.$selectedFormFields | async"
                                       [placeholder]="'wbo.search.more.placeholder'"></wbo-more-select-control>
        </div>
        <div class="form-main-localisation" *ngIf="searchModel.isEntityLocalisable() && (LOCALISATION | booleanConfig)">
            <fui-localisation-control [localised]="localiseFiltersSelected" (click)="openLocalisationDialog()" id="localisation-control"
                                      [title]="'wbo.search.localisation.label' | translate"
                                      [label]="'wbo.search.localisation.label' | translate"></fui-localisation-control>
        </div>
    </div>
    <div class="form-footer" id="extended-fields">
        <ng-content select="wbo-search-form-extended-fields"></ng-content>
    </div>
</div>
